import { AllergenStatus } from './recipeV2Types';

export const normalizeRecipeAllergenStatus = (value: string | null | undefined): AllergenStatus => {
  switch ((value ?? '').replace(/[\s_.-]/g, '').toLowerCase()) {
    case 'contains':
      return AllergenStatus.Contains;
    case 'maycontain':
      return AllergenStatus.MayContain;
    case 'notpresent':
    case 'doesnotcontain':
      return AllergenStatus.NotPresent;
    case 'freefrom':
      return AllergenStatus.FreeFrom;
    case 'unknown':
    case '':
    default:
      return AllergenStatus.Unknown;
  }
};

export const recipeAllergenRiskPriority = (status: AllergenStatus): number => {
  switch (status) {
    case AllergenStatus.Contains:
      return 5;
    case AllergenStatus.MayContain:
      return 4;
    case AllergenStatus.Unknown:
      return 3;
    case AllergenStatus.NotPresent:
      return 2;
    case AllergenStatus.FreeFrom:
      return 1;
    default:
      return 3;
  }
};
